/* Field errors */
export const FIELD_ERROR_ORDER_NUMBER_REQUIRED =
    'Order number is a required field'
export const FIELD_ERROR_EMAIL_REQUIRED = 'Email address is a required field'
export const FIELD_ERROR_EMAIL_INVALID = 'Enter a valid email'

export const PRE_PROCESSING = 'pre_processing'
export const PROCESSING = 'processing'
export const POST_PROCESSING = 'post_processing'
export const PROCESSED = 'processed'
export const CANCELLED = 'cancelled'
export const VOIDED = 'voided'

export const ORDERING = 'ordering'
export const CREATED = 'created'
export const REFUNDED = 'refunded'
